<template>
  <div class="crud_module--opening_hour">
    <br>
    <div class="row">
      <div class="item">
        <div class="cps">
          <div class="cp_title"><input type="checkbox" v-model="select_all" @change="selectAll()">{{$t('menu.item.cp')}}</div>
          <div class="cp_content">
            <div class="el-row" style="margin-left: -5px; margin-right: -5px;">
              <div class="cp el-col el-col-6" v-for="row in cps" :key="row.cp_id">
                <input type="checkbox" :id="'cps-'+row.cp_id" :value="row.cp_id" @change="selectOne()" v-model="select_cp">
                <label :for="'cps-'+row.cp_id" class="label">{{row.cp_no}}</label>
              </div>
            </div>
            <div class="action">
              <el-button size="small" type="primary" @click="confirm">{{ $t("button.confirm") }}</el-button>
              <!-- <el-button size="small" type="primary" @click="test">test</el-button> -->
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ["data","col","k"],
  async beforeMount() {
    this.id = this.$route.params.id;
    await this.init();
  },
  methods: {
    async init() {
      var _this = this;
      await this.$axios.get(`/cps`, {
        params: {
          size: 99999,
          page: 0,
          trash: 0
        }
      }).then(res=>{
        let data = res.data.response.dataset;
        _this.cps = data.content;
        return true;
      }).catch(err=>{ return false; });

      await this.$axios.get(`/cp_opening_hour/${this.id}`, {}).then(res=>{

        _this.select_cp = [];
        for(var i in res.data){
          var d = res.data[i];
          _this.select_cp.push(d.cp_id);
        }
        _this.selectOne();
        // console.log(res.data);
        return true;
      }).catch(err=>{ return false; });
    },
    async test(){
      await this.$axios.post(`/cp_opening_hour/test`, {
        cpIds:this.select_cp
      }).then(res=>{
        if(res.data == "Success"){
          this.$message({
            message: this.$t("message.save_successfully"),
            type: 'success'
          });
        }
        else {
          this.$message({
            message: this.$t("error.generic"),
            type: 'error'
          });
        }
      }).catch(err=>err);
    },
    async confirm(){
      await this.$axios.post(`/cp_opening_hour`, {
        openingHourId:this.id,
        cpIds:this.select_cp
      }).then(res=>{
        if(res.data == "Success"){
          this.$message({
            message: this.$t("message.save_successfully"),
            type: 'success'
          });
        }
        else {
          this.$message({
            message: this.$t("error.generic"),
            type: 'error'
          });
        }
      }).catch(err=>err);
    },
    selectAll(){
      var list = this.cps;
      var arr = [];
      if(this.select_all){
        for(var i in list){
          var cp = list[i];
          arr.push(cp.cp_id);
        }
      }
      this.select_cp = arr;
    },
    selectOne(){
      var length = this.cps.length;
      var tlength = this.select_cp.length;
      if(length == tlength){
        this.select_all = true;
      }
      else {
        this.select_all = false;
      }
    }
  },
  computed:{
  },
  data() {
    return {
      cps:[],
      select_cp:[],
      id:0,
      select_all:false,
      value:undefined
    }
  }
}
</script>

<style lang="scss">
.crud_module--opening_hour{
  .row{
    display: flex;
    margin-bottom: 20px;
    width: 100%;
    max-width: 100%;
    .item{
      flex-grow: 1;
      display: flex;
      width: 100%;
      font-size: x-small;
      // margin-right: 20px;
      .item__type--tab{
        flex-grow: 1;
        overflow-x: auto;
      }
      .data{
        width: 100%;
        display: flex;
      }
      .label{
        width: 130px;
        min-width: 130px;
        display: flex;
        align-items: center;
      }
      .value{
        min-width: 200px;
        width: 100%;
        > input{
          width: calc(100% - 10px);
          height: 25px;
          padding: 5px;
        }
        > select{
          width: 100%;
          height: 35px;
          padding: 5px;
        }
      }
      .cp_title{
        margin-bottom: 10px;
        font-size: small;
        background: #414e75;
        color: white;
        padding: 5px 10px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
      }
      .cp{
        display: flex;
        padding-left: 5px; 
        padding-right: 5px;
      }
      .cps{
        border: 1px solid #e3e3e3;
        border-radius: 5px;
        box-shadow: 0px 1px 5px #ddd;
        display: flex;
        flex-direction: column;
        background: white;
        width: 100%;
      }
      .action{
        margin: 5px;
      }
    }
  }
}
</style>